import styled from 'styled-components'
import arrowImg from '../../assets/arrow.png'
import { chunk } from '../../utils/util'
import { useNavigate } from 'react-router-dom'
import { useState } from "react";
import {Cookies} from 'react-cookie';
import moment from "moment";
import PopUp1Pc from "../../components/PopUp1Pc";

function Page2Pc(props) {
  let popup = props.popup
  let goods = props.goods
  goods = chunk(goods, 2)
  const cookies = new Cookies();
  const showTodayFlag = () => {
    if(cookies.get("doNotShowToday")!==null && cookies.get("doNotShowToday") !== undefined){
        if(cookies.get("doNotShowToday") ==  moment().format("YYYYMMDD")){
          return false;
        }else{
          return true;
        }
    }
    return true;
  };
  const [showPopUp, setShowPopUp] = useState(showTodayFlag);
  const doNotShowToday = () => {
    cookies.set("doNotShowToday", moment().format("YYYYMMDD")); 
    setShowPopUp(false);
  };
  const close = () => {
    setShowPopUp(false);
  };
  const navigate = useNavigate()
  return (
    <>
      {showPopUp && popup != null ? (
        <PopUp1Pc doNotShowToday={doNotShowToday} close={close} popup={popup} />
      ) : null}
    <MainContainer>
      {goods.map((el) => {
        return (
          <Row key={el.index}>
            {el.map((el2) => {
              return (
                <Box
                  bgcolor={el2.gsBgColor}
                  mainFileDto={el2.gsMainFileDto}
                  key={el2.gsSeq}
                  onClick={() => {
                    navigate(`/goods/${el2.gsSeq}`)
                  }}
                >
                  <Text1>{el2.gsName}</Text1>
                  <Text2>{el2.gsEngName}</Text2>
                  <Button>
                    <ArrowImg src={arrowImg} />
                  </Button>
                </Box>
              )
            })}
          </Row>
        )
      })}
    </MainContainer>
    </>
  )
}

export default Page2Pc
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 95vh;
`
const Row = styled.div`
  display: flex;
  flex-direction: row;
`
const Box = styled.div`
  display: flex;
  flex-direction: column;
  width: 40vw;
  height: 30vh;
  background: ${(props) =>
    props.mainFileDto !== null
      ? `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), no-repeat url(${process.env.REACT_APP_BASE_RESOURCES_API}${props.mainFileDto.filePath})`
      : `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), ${props.bgcolor}`};
  background-size: cover;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`
const Text1 = styled.p`
  font-size: 25.3px;
  color: #fff;
  font-family: Noto Sans KR;
  font-weight: normal;
`
const Text2 = styled.p`
  font-size: 31.6px;
  color: #fff;
  font-family: GMarketSans;
  font-weight: 500;
  margin-top: 5px;
  letter-spacing: 1px;
`
const Button = styled.div`
  cursor: pointer;
  width: 145.6px;
  height: 44.3px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0.3px solid #fff;
  margin-top: 25px;
`
const ArrowImg = styled.img`
  width: 60px;
  height: 10px;
`
